import { render, staticRenderFns } from "./CashboxCategoryItem.vue?vue&type=template&id=0b4b02bf&scoped=true"
import script from "./CashboxCategoryItem.vue?vue&type=script&lang=js"
export * from "./CashboxCategoryItem.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CashboxCategoryItem.vue?vue&type=style&index=1&id=0b4b02bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b02bf",
  null
  
)

export default component.exports